import config from "../../../config";
import Heading from "../../atoms/Heading";
import { SectionDetails } from "../../molecules/SectionDetails";
import { SkillItem, SkillName, SkillsContainer } from "./style";

function Skills() {
  return (
    <SectionDetails
      column
      heading={<Heading>Skills</Heading>}
      details={
        <SkillsContainer>
          {config.skills.map((skill, index) => (
            <SkillItem key={index}>
              <img src={skill.icon} alt={skill.name} />
              <SkillName>{skill.name}</SkillName>
            </SkillItem>
          ))}
        </SkillsContainer>
      }
    />
  );
}

export default Skills;
